import React from 'react';
import { Grid, Box, Paper, useMediaQuery, Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CashFlowList from './CashFlowList';
import {
    DateFromToPicker, UpdateFromCallback, UpdateToCallback, ResetCallback,
    FromToContextProvider, useFromToContext,
} from '../../shared';
import { DownloadCsvIconButton } from '../../../ui-kit';
import { GET_CASH_DRAWER_REPORT } from '../graphql';

const CashFlow = () => {
    const matches = useMediaQuery('(min-width:650px)');
    const { t } = useTranslation();
    const { dateFromTo, setDateFromTo } = useFromToContext();

    const updateFromContext: UpdateFromCallback = (from, dateTo) => {
        if(from && dateTo && (from.valueOf() <= dateTo.valueOf())){
            setDateFromTo({ from, to: dateTo.toJSDate() });
        }
        if(from === null){
            resetContext();
        }
    };

    const updateToContext: UpdateToCallback = (to, dateFrom) => {
        if(to && dateFrom && (to.valueOf() >= dateFrom.valueOf())){
            setDateFromTo({ to, from: dateFrom.toJSDate() });
        }
        if(to === null){
            resetContext();
        }
    };

    const resetContext: ResetCallback = () => {
        setDateFromTo(undefined);
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box p={2} component={Paper}>
                    <Box display='flex' alignItems='center' flexWrap='wrap'>
                        <Box width={320}>
                            <DateFromToPicker
                                updateToCallback={updateToContext}
                                updateFromCallback={updateFromContext}
                                resetCallback={resetContext}
                            />
                        </Box>
                        {matches
                            ? (
                                <Box display='flex' alignSelf='stretch' mx={2}>
                                    <Divider flexItem orientation='vertical' />
                                </Box>
                            )
                            : null}
                        <DownloadCsvIconButton
                            query={GET_CASH_DRAWER_REPORT}
                            propertyKey="cashDrawerReport"
                            fileName={t('cash_drawer_report')}
                            variables={{ dateFromTo }}
                        />
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <CashFlowList />
            </Grid>
        </Grid>
    );
};

export default () => (
    <FromToContextProvider>
        <CashFlow />
    </FromToContextProvider>
);
